import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Tags } from '@tryghost/helpers-gatsby'
import { readingTime as readingTimeHelper } from '@tryghost/helpers'

const PostCard = ({ post, showTag = true }) => {
    const url = `/${post.slug}/`
    const readingTime = readingTimeHelper(post)
    console.log(post)

    return (
        <Link to={url} className="post-card">
            <header className="post-card-header">
                <h2 className="post-card-title">
                    {post.title}
                </h2>
                {post.tags && showTag ?
                    <div className="post-card-tags"> 
                        <Tags 
                            post={post} 
                            visibility="public" 
                            autolink 
                            permalink="tag/:slug"
                        />
                    </div> :
                    null
                }
            </header>
            <section className="post-card-excerpt">{post.excerpt}</section>
            <footer className="post-card-footer">
                <div className="post-card-footer-left">
                    <div>{readingTime}</div>
                </div>
                <div className="post-card-footer-right">
                </div>
            </footer>
        </Link>
    )
}

PostCard.propTypes = {
    post: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        feature_image: PropTypes.string,
        featured: PropTypes.bool,
        tags: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            })
        ),
        excerpt: PropTypes.string.isRequired,
        primary_author: PropTypes.shape({
            name: PropTypes.string.isRequired,
            profile_image: PropTypes.string,
        }).isRequired,
    }).isRequired,
    showTag: PropTypes.bool,
}

export default PostCard
